class ss_slideshow extends HTMLElement {
  constructor() {
    super();
    this.intervalID;
    this.startSlideshowInterval;
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchEndX = 0;
    this.touchEndY = 0;
    this.threshold = 50;
    this.allowedTime = 500;
    this.startTime = 0;
    this.addTouchListeners();    
    Array.from(this.querySelector("[dots]").children).forEach((dot) => {
      dot.addEventListener("click", () => {
        if(!dot.classList.contains("active_dot")) {
          this.goTo(parseInt(dot.getAttribute("index")));
        }
      });
    });
  }
  addTouchListeners() {
    this.addEventListener('touchstart', (e) => this.onTouchStart(e), false);
    this.addEventListener('touchmove', (e) => this.onTouchMove(e), false);
    this.addEventListener('touchend', (e) => this.onTouchEnd(e), false);
  }
  onTouchStart(e) {
    const touch = e.changedTouches[0];
    this.touchStartX = touch.pageX;
    this.touchStartY = touch.pageY;
    this.startTime = new Date().getTime();
  }
  onTouchMove(e) {
    const touch = e.changedTouches[0];
    this.touchEndX = touch.pageX;
    this.touchEndY = touch.pageY;
    const deltaX = this.touchEndX - this.touchStartX;
    const deltaY = this.touchEndY - this.touchStartY;
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > this.threshold) {
      if(e.cancelable) {
        e.preventDefault();
      }
    }
  }
  onTouchEnd(e) {
    const deltaX = this.touchEndX - this.touchStartX;
    const deltaY = this.touchEndY - this.touchStartY;
    const elapsedTime = new Date().getTime() - this.startTime;
    if (elapsedTime <= this.allowedTime) {
      if (Math.abs(deltaX) > this.threshold && Math.abs(deltaX) > Math.abs(deltaY)) {
        if (deltaX < 0) {
          this.next();
        } else {
          this.previous();
        }
      }
    }
  }
  next() {
    const active = this.querySelector("[wrapper]").querySelector(".active_slide");
    const dots = this.querySelector("[dots]");
    const curDot = dots.querySelector(".active_dot");
    if(this.querySelector("[wrapper]").lastElementChild == active) {
      active.classList.remove("active_slide");
      this.querySelector("[wrapper]").firstElementChild.classList.add("active_slide");
      Array.from(dots.children).forEach((dot) => {
        dot.classList.remove("active_dot");
      });
      dots.children[0].classList.add("active_dot");
      active.classList.add("slide_off");
      setTimeout(() => {
        active.classList.remove("slide_off");
      }, 1000);
    } else {
      active.classList.remove("active_slide");
      active.nextElementSibling.classList.add("active_slide");
      curDot.classList.remove("active_dot");
      curDot.nextElementSibling.classList.add("active_dot");
      active.classList.add("slide_off");
      setTimeout(() => {
        active.classList.remove("slide_off");
      }, 1000);
    }
    this.resetInterval();
  }
  previous() {
    const active = this.querySelector("[wrapper]").querySelector(".active_slide");
    const dots = this.querySelector("[dots]");
    const curDot = dots.querySelector(".active_dot");
    if(this.querySelector("[wrapper]").firstElementChild == active) {
      active.classList.remove("active_slide");
      this.querySelector("[wrapper]").lastElementChild.classList.add("active_slide");
      Array.from(dots.children).forEach((dot) => {
        dot.classList.remove("active_dot");
      });
      dots.children[dots.children.length - 1].classList.add("active_dot");
      active.classList.add("slide_off");
      setTimeout(() => {
        active.classList.remove("slide_off");
      }, 1000);
    } else {
      active.classList.remove("active_slide");
      active.previousElementSibling.classList.add("active_slide");      
      curDot.classList.remove("active_dot");
      curDot.previousElementSibling.classList.add("active_dot");
      active.classList.add("slide_off");
      setTimeout(() => {
        active.classList.remove("slide_off");
      }, 1000);
    }
    this.resetInterval();
  }
  goTo(index) {
    const active = this.querySelector("[wrapper]").querySelector(".active_slide");
    const dots = this.querySelector("[dots]");
    const curDot = dots.querySelector(".active_dot");
    active.classList.remove("active_slide");
    curDot.classList.remove("active_dot");
    dots.children[index].classList.add("active_dot");
    this.querySelector("[wrapper]").children[index].classList.add("active_slide");
    this.resetInterval();
  }
  startInterval(duration) {
    this.startSlideshowInterval = () => {
      clearInterval(this.intervalID);
      this.intervalID = setInterval(() => {
        this.next();
      }, duration);
    };
    this.startSlideshowInterval();
  }
  resetInterval() {
    clearInterval(this.intervalID);
    if(this.querySelector("[autoslide]")) {
      this.startSlideshowInterval();
    }
  }
}

customElements.define('ss-slideshow', ss_slideshow);